// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dl-a";
export var fulfillmentFormRail = "_dl-9";
export var headerTitleRow = "_dl-c";
export var orderDetailsWrapper = "_dl-7";
export var orderLinkTrigger = "_dl-2";
export var paymentInformationGrid = "_dl-h";
export var paymentSummaryColumn = "_dl-i";
export var shipmentContainer = "_dl-b";
export var shipmentDetailsMainPane = "_dl-8";
export var shipmentNavigationCard = "_dl-5";
export var shipmentNavigationRail = "_dl-3";
export var shipmentNavigationRailHeader = "_dl-4";
export var shipmentSummaryFact = "_dl-e";
export var shipmentSummaryGrid = "_dl-d";
export var shipmentSummaryMetadataRow = "_dl-f";
export var shipmentSummaryTags = "_dl-g";
export var shipmentWorkspace = "_dl-0";
export var shipmentWorkspaceContent = "_dl-6";
export var shipmentWorkspaceHeader = "_dl-1";